import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Prerendered pages (see scripts/prerender.js) ship real HTML inside #root for
// crawlers and first paint. React then mounts the identical tree on top. We use
// createRoot (not hydrateRoot) on purpose: the markup contains JSX whitespace
// text nodes that don't survive strict hydration, and a mismatch would make
// React 19 re-render the whole root anyway — so a clean client mount is simpler
// and error-free while keeping the full prerender SEO benefit.
const container = document.getElementById("root");
container.innerHTML = "";
createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
